import { orchestrator } from 'satcheljs';
import { updateSelectedCalendars, selectedCalendarsUpdated } from '../actions/publicActions';
import { updateSelectedCalendarsInStore } from '../actions/internalActions';
import { updateSelectedCalendarsState } from '../services/updateSelectedCalendarsState';

orchestrator(updateSelectedCalendars, actionMessage => {
    const { calendarIds, primarySmtpAddress } = actionMessage;
    updateSelectedCalendarsInStore(calendarIds, primarySmtpAddress);
    selectedCalendarsUpdated(calendarIds, primarySmtpAddress);
    updateSelectedCalendarsState(calendarIds, primarySmtpAddress);
});
